<main class="text-start">
  <h1 class="page-title">
    <a [routerLink]="['/products']" class="text-[#8A8AA3] me-0.5 ms-2 hover:text-purple-800">
      <i class="bi" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
      {{ 'products.back' | translate }}
    </a>
    {{ 'products.add_new_page_title' | translate }}
  </h1>

  <app-product-form (formSubmit)="submit($event)" [disableSubmitButton]="disableSubmitButton" [loading]="loading"></app-product-form>
</main>
